import { IsValidEmail } from "common/EmailUtils";
import Input from "components/Common/Input";
import Copyright from "components/Copyright";
import PageMeta from "components/PageMeta";
import React, { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, Col, Container, Row, Spinner } from "reactstrap";
import { requestCustomerPasswordReset } from "services/AccountApi";
import { ThemeLogo, useTheme } from "theme";

const CustomerForgotPassword: React.FC = () => {
    const theme = useTheme();
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);

    const submit = async (event: FormEvent) => {
        event.preventDefault();
        if (!IsValidEmail(email) || submitting) return;

        setSubmitting(true);
        setError(false);
        try {
            await requestCustomerPasswordReset(email, window.location.href);
            setSubmitted(true);
        } catch {
            setError(true);
        } finally {
            setSubmitting(false);
        }
    };

    return <>
        <PageMeta title={`Forgot password | ${theme.brand.companyName}`} hideTitle />
        <div className="account-pages my-0 pt-sm-5">
            <Container>
                <Row className="justify-content-center">
                    <Col md={10} className="text-center mt-3">
                        <ThemeLogo variant="dark" className="customer-login-logo" />
                        <div className="text-center login-height" />
                        <Row>
                            <Col lg={3} />
                            <Col lg={6}>
                                <Card className="overflow-hidden">
                                    <div className="p-lg-5 p-4">
                                        <h5>Forgot password</h5>
                                        <p className="text-muted mb-4">
                                            Enter your email address and we’ll send you a link to set a new password.
                                        </p>
                                        {submitted ? <Alert color="success">
                                            If an account exists for this email address, the reset link is on its way.
                                        </Alert> : <form onSubmit={submit}>
                                            <Input
                                                autoFocus
                                                autocomplete="email"
                                                name="email"
                                                type="email"
                                                placeholder="Email address"
                                                value={email}
                                                onChange={setEmail}
                                            />
                                            {error && <Alert className="mt-4" color="danger">
                                                We couldn’t send the request. Please try again.
                                            </Alert>}
                                            <button
                                                className="btn btn-primary w-100 mt-4 waves-effect waves-light"
                                                disabled={!IsValidEmail(email) || submitting}
                                                type="submit"
                                            >
                                                {submitting && <Spinner size="sm" className="me-2" />}
                                                Send reset link
                                            </button>
                                        </form>}
                                        <Link className="d-inline-block mt-4" to="/login">Back to login</Link>
                                    </div>
                                </Card>
                                <div className="text-center"><Copyright /></div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    </>;
};

export default CustomerForgotPassword;
